import styles from "../../styles/HeaderAuth.module.css";
import * as auth from "../store/ducks/auth.duck";
import * as config from "../store/ducks/config.duck";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getIniciais, getNomeSobrenome } from "../utils/Utils";
import { RiArrowDownSLine, RiCloseFill, RiMenuFill } from "react-icons/ri";
import { useEffect, useRef, useState } from "react";

export default function HeaderAuth() {
    const [showMenuCliente, setShowMenuCliente] = useState(false);
    const [openMenuMobile, setOpenMenuMobile] = useState(false);

    const location = useLocation();

    const dispatch = useDispatch();

    const history = useHistory();

    const { user } = useSelector((state) => state.auth);

    const dropdownRef = useRef(null);
    const asideRef = useRef(null);

    useEffect(() => {
        document.body.style.setProperty("overflow", "auto", "important");
    }, [history.location.pathname]);

    const abrirMenu = (status) => {
        setOpenMenuMobile(status);
        if (status) {
            window.scrollTo(0, 0);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMenuCliente(false);
            }
            if (asideRef.current && !asideRef.current.contains(event.target)) {
                abrirMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (openMenuMobile) {
            document.body.style.setProperty("overflow", "hidden", "important");
        } else {
            document.body.style.setProperty("overflow", "auto", "important");
        }

        return () => document.body.style.setProperty("overflow", "auto", "important");
    }, [openMenuMobile]);

    const handleClickNome = () => {
        if (window.innerWidth > 1400) {
            setShowMenuCliente(!showMenuCliente);
        } else {
            setOpenMenuMobile(!openMenuMobile);
        }
    };

    return (
        <>
            <header className={styles.container}>
                <div className={styles.boxLinksLogo}>
                    <div onClick={() => abrirMenu(!openMenuMobile)} className={styles.menuMobile}>
                        <RiMenuFill size={25} color="#222222" />
                    </div>

                    <img src="/images/logo.png" alt="Logo" className={styles.logo} onClick={() => history.push("/")} />

                    <div className={styles.boxLinks}>
                        <div onClick={() => history.push("/inicio")} className={`${styles.link} ${location.pathname.includes("/inicio") ? styles.linkSelected : ''}`}>
                            <p>Visão geral</p>
                        </div>

                        <div onClick={() => history.push("/transacoes")} className={`${styles.link} ${location.pathname.includes("/transacoes") ? styles.linkSelected : ''}`}>
                            <p>Transações</p>
                        </div>

                        <div onClick={() => history.push("/cartoes")} className={`${styles.link} ${location.pathname.includes("/cartoes") ? styles.linkSelected : ''}`}>
                            <p>Cartões de crédito</p>
                        </div>

                        <div onClick={() => history.push("/contas-bancarias")} className={`${styles.link} ${location.pathname.includes("/contas-bancarias") ? styles.linkSelected : ''}`}>
                            <p>Contas bancárias</p>
                        </div>

                        <div onClick={() => history.push("/tags-categorias")} className={`${styles.link} ${location.pathname.includes("/tags-categorias") ? styles.linkSelected : ''}`}>
                            <p>Tags e categorias</p>
                        </div>

                        <div onClick={() => history.push("/insights-inteligentes")} className={`${styles.link} ${location.pathname.includes("/insights-inteligentes") ? styles.linkSelected : ''}`}>
                            <p>Insights inteligentes</p>
                        </div>
                    </div>
                </div>

                <div className={styles.boxUsuario}>
                    <div className={styles.circuloNome} onClick={handleClickNome}>
                        <p>{getIniciais(user?.nome)}</p>
                    </div>

                    <div className={styles.boxNomeSeta}>
                        <div className={styles.nomeUsuario} onClick={() => setShowMenuCliente(!showMenuCliente)}>
                            <p>{getNomeSobrenome(user?.nome)}</p>

                            <RiArrowDownSLine size={20} color="#777777" />
                        </div>

                        {showMenuCliente && (
                            <div className={styles.dropdownUsuario} ref={dropdownRef}>
                                <div className={styles.boxInfoUsuario} style={{ borderBottom: "1px solid #E4E4E4" }}>
                                    <div className={styles.circuloNome}>
                                        <p>{getIniciais(user?.nome)}</p>
                                    </div>

                                    <div className={styles.infoUsuario}>
                                        <p>{user?.nome}</p>

                                        <small>{user?.email}</small>
                                    </div>
                                </div>

                                <div
                                    className={styles.itemDropdown}
                                    onClick={() => {
                                        history.push("/minha-conta", { menu: 'perfil' });
                                        setShowMenuCliente(false);
                                    }}
                                >
                                    <img src="/icons/user.png" alt="Icone" />

                                    <p>Minha conta</p>
                                </div>

                                <div
                                    className={styles.itemDropdown}
                                    onClick={() => {
                                        history.push("/minha-conta", { menu: 'configurar-assistente' });
                                        setShowMenuCliente(false);
                                    }}
                                >
                                    <img src="/icons/smart-compose.png" alt="Icone" />

                                    <p>Configurar assistente</p>
                                </div>

                                <div
                                    className={styles.itemDropdown}
                                    onClick={() => {
                                        history.push("/minha-conta", { menu: 'gerenciar-assinatura' });
                                        setShowMenuCliente(false);
                                    }}
                                >
                                    <img src="/icons/credit-card.png" alt="Icone" />

                                    <p>Gerenciar assinatura</p>
                                </div>

                                <div
                                    className={styles.itemDropdown}
                                    onClick={() => {
                                        history.push("/termos-de-uso");
                                        setShowMenuCliente(false);
                                    }}
                                >
                                    <img src="/icons/description.png" alt="Icone" />

                                    <p>Termos de Uso</p>
                                </div>

                                <div
                                    className={styles.itemDropdown}
                                    style={{ borderTop: "1px solid #E4E4E4" }}
                                    onClick={() => {
                                        dispatch(auth.actions.logout());
                                        dispatch(config.actions.resetPhone());
                                        setShowMenuCliente(false);
                                    }}
                                >
                                    <img src="/icons/logout.png" alt="Icone" />

                                    <p>Sair</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {openMenuMobile && (
                <>
                    <aside className={styles.menuLateralMobile} ref={asideRef}>
                        <div className="d-flex align-items-center justify-content-between" style={{ padding: 20 }}>
                            <img src="/images/logo.png" alt="Logo" className={styles.logoMobile} onClick={() => history.push("/")} />

                            <RiCloseFill size={22} color="#999999" onClick={() => abrirMenu(false)} style={{ cursor: "pointer" }} />
                        </div>

                        <div className="d-flex flex-column justify-content-between" style={{ height: "calc(100% - 62px)" }}>
                            <div className={styles.containerLinksMobile}>
                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/inicio");
                                        abrirMenu(false);
                                    }}
                                >
                                    <p>Visão geral</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/transacoes");
                                        abrirMenu(false);
                                    }}
                                >
                                    <p>Transações</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/cartoes");
                                        abrirMenu(false);
                                    }}
                                >
                                    <p>Cartões de crédito</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/contas-bancarias");
                                        abrirMenu(false);
                                    }}
                                >
                                    <p>Contas bancárias</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/tags-categorias");
                                        abrirMenu(false);
                                    }}
                                >
                                    <p>Tags e categorias</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    style={{ borderBottom: "1px solid #E4E4E4" }}
                                    onClick={() => {
                                        history.push("/insights-inteligentes");
                                        abrirMenu(false);
                                    }}
                                >
                                    <p>Insights inteligentes</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/minha-conta", { menu: 'perfil' });
                                        abrirMenu(false);
                                    }}
                                >
                                    <img src="/icons/user.png" alt="Icone" />

                                    <p>Minha conta</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/minha-conta", { menu: 'configurar-assistente' });
                                        abrirMenu(false);
                                    }}
                                >
                                    <img src="/icons/smart-compose.png" alt="Icone" />

                                    <p>Configurar assistente</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/minha-conta", { menu: 'gerenciar-assinatura' });
                                        abrirMenu(false);
                                    }}
                                >
                                    <img src="/icons/credit-card.png" alt="Icone" />

                                    <p>Gerenciar assinatura</p>
                                </div>

                                <div
                                    className={styles.boxLinksMobile}
                                    onClick={() => {
                                        history.push("/termos-de-uso");
                                        abrirMenu(false);
                                    }}
                                >
                                    <img src="/icons/description.png" alt="Icone" />

                                    <p>Termos de Uso</p>
                                </div>
                            </div>

                            <div
                                className={styles.boxLinksMobile}
                                style={{ borderTop: "1px solid #E4E4E4" }}
                                onClick={() => {
                                    dispatch(auth.actions.logout());
                                    dispatch(config.actions.resetPhone());
                                    setShowMenuCliente(false);
                                }}
                            >
                                <img src="/icons/logout.png" alt="Icone" />

                                <p>Sair</p>
                            </div>
                        </div>
                    </aside>

                    <div className={styles.overlay} />
                </>
            )}
        </>
    );
}
